(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-version', {
            parent: 'entity',
            url: '/document-version',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentVersion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-version/document-versions.html',
                    controller: 'DocumentVersionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentVersion');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-version-detail', {
            parent: 'entity',
            url: '/document-version/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentVersion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-version/document-version-detail.html',
                    controller: 'DocumentVersionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentVersion');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentVersion', function($stateParams, DocumentVersion) {
                    return DocumentVersion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-version',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-version-detail.edit', {
            parent: 'document-version-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version/document-version-dialog.html',
                    controller: 'DocumentVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentVersion', function(DocumentVersion) {
                            return DocumentVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-version.new', {
            parent: 'document-version',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version/document-version-dialog.html',
                    controller: 'DocumentVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                versionNo: null,
                                fileRef: null,
                                data: null,
                                dataContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document-version', null, { reload: 'document-version' });
                }, function() {
                    $state.go('document-version');
                });
            }]
        })
        .state('document-version.edit', {
            parent: 'document-version',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version/document-version-dialog.html',
                    controller: 'DocumentVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentVersion', function(DocumentVersion) {
                            return DocumentVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-version', null, { reload: 'document-version' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-version.delete', {
            parent: 'document-version',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version/document-version-delete-dialog.html',
                    controller: 'DocumentVersionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentVersion', function(DocumentVersion) {
                            return DocumentVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-version', null, { reload: 'document-version' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
